import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { FadeUp } from "@/components/Reveal";

const LINES = [
  "Kalabalıkta kaybolan bakışları, yarım kalan hikâyeleri,",
  "aceleye gelen yakınlıkları gördük.",
  "Swipe’ların hızına, yüzeysel eşleşmelere, bitmeyen seçeneklere baktık",
  "ve başka bir yol hayal ettik.",
  "Aşkı daha sakin, daha özenli, daha derin istedik.",
  "Tesadüfe bırakılmayacak kadar değerli olduğuna inandık.",
  "Bu yüzden gürültüyü azalttık.",
  "Five Star, birbirini bulması gereken insanların yollarını kesiştirmek için var.",
  "Özenle, dikkatle, insanı gerçekten görerek.",
  "Doğru bağlar, daha iyi bir hikâye yazar.",
  "Daha çok deneyim değil, aşkta daha fazlası olsun diye buradayız.",
];

export default function Manifesto() {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", reduce ? "-8%" : "8%"]);

  return (
    <section ref={ref} data-testid="manifesto-section" className="relative overflow-hidden bg-[#1a0508] text-ivory-light">
      <motion.picture style={{ y }} className="absolute -inset-y-[10%] inset-x-0 block will-change-transform" aria-hidden="true">
        <source media="(min-width: 768px)" srcSet="/manifesto/dream-wide.jpg" />
        <img
          src="/manifesto/dream-portrait.jpg"
          alt=""
          data-testid="manifesto-bg-image"
          className="w-full h-full object-cover"
          loading="lazy"
          decoding="async"
        />
      </motion.picture>
      <div aria-hidden="true" className="absolute inset-0 bg-[#1a0508]/40" />
      <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-r from-[#1a0508]/85 via-[#1a0508]/45 to-[#1a0508]/15" />
      <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-b from-[#1a0508]/70 via-transparent to-[#1a0508]/70" />

      <div className="relative max-w-7xl mx-auto px-6 min-h-screen flex items-center py-24 sm:py-28">
        <div className="max-w-xl lg:max-w-2xl">
          <FadeUp>
            <p className="font-cinzel text-[10px] sm:text-[11px] tracking-[0.4em] text-gold-subtle/80">Manifesto</p>
          </FadeUp>
          <FadeUp delay={0.15}>
            <h2
              data-testid="manifesto-title"
              className="mt-6 font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.12] tracking-tight drop-shadow-[0_4px_24px_rgba(0,0,0,0.7)]"
            >
              Gürültülü bir dünyada, <em className="italic text-rose-soft">sesleri biraz kısıyoruz.</em>
            </h2>
          </FadeUp>
          <FadeUp delay={0.35}>
            <div
              data-testid="manifesto-body"
              className="mt-7 sm:mt-8 pl-5 sm:pl-6 border-l border-gold/50 font-serif text-base sm:text-lg lg:text-[1.35rem] font-light leading-[1.5] text-ivory/90 drop-shadow-[0_2px_14px_rgba(0,0,0,0.7)]"
            >
              {LINES.map((l, i) => (
                <p key={i} className={i === LINES.length - 1 ? "mt-3 italic text-rose-soft" : ""}>
                  {l}
                </p>
              ))}
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
